import { formatNumber } from 'utils/number';
import type { SelectedArea } from './create-area-types';
import styles from './create-area-panel.module.scss';

interface SelectionSummaryProps {
  rows: SelectedArea[];
  /** What one row is called ("Well"). */
  singular: string;
  /** What several are called ("Wells"). */
  noun: string;
}

/**
 * The checked rows the panel builds from, counted and named, above the form.
 *
 * @param {SelectionSummaryProps} props - The rows and what to call them.
 * @return {JSX.Element} The count and the names.
 */
export function SelectionSummary({
  rows,
  singular,
  noun,
}: SelectionSummaryProps): JSX.Element {
  return (
    <div className={styles.selection}>
      <p className={styles.selectionCount}>
        {formatNumber(rows.length, 0, 0)}{' '}
        {(rows.length === 1 ? singular : noun).toLowerCase()} selected
      </p>
      <ul className={styles.selectionList}>
        {rows.map((area) => (
          <li key={area.id}>{area.name}</li>
        ))}
      </ul>
    </div>
  );
}
